export default "__VITE_ASSET__4e5a8f8e__"